<template>
  <div class="trdetall">
    <div class="details_listp">
      <!-- 评论框 -->
      <div class="details_plwo">
        <div class="details_inp">
          <el-input
            type="textarea"
            :rows="4"
            resize="none"
            :maxlength="100"
            placeholder="请输入内容"
            v-model="plone"
          >
          </el-input>
        </div>
        <div class="pl_btns">
          <el-button
            class="plbtnal"
            size="mini"
            type="primary"
            :loading="btnload"
            @click="tijone(inparameter)"
            >提交评论</el-button
          >
        </div>
      </div>
      <div v-if="comment.rows.length == 0">
        <el-empty description="暂无评论"></el-empty>
      </div>
      <div class="det_listpchile" v-else>
        <!-- <h3 style="color: #007aff; font-weight: bold">评论</h3> -->
        <!-- 楼层内容 -->
        <div v-for="(itemb, keys) in comment.rows" :key="keys" class="det_comment">
          <!-- 头像 -->
          <div class="user_comment">
            <div class="pl_cent">
              <el-avatar :size="40" :src="itemb.traineeAvatar">
                <img :src="morenavat" alt="" />
              </el-avatar>
              <div class="usname_comment">
                <p class="nametxt_comment">
                  {{ itemb.traineeName }}
                  <span class="time_intera">{{ itemb.contentTime }}</span>
                  <span
                    class="deltxt"
                    v-if="tokens && itemb.traineeId == $store.getters.userId"
                    @click="delintera(itemb, inparameter)"
                    >删除</span
                  >
                </p>
                <!-- 评论楼层内容 -->
                <span class="content_txtasv" v-html="itemb.content"></span>
              </div>
            </div>
          </div>

          <div class="cont_pl" v-if="itemb.replyContent !== null">
            <!-- 头像 -->
            <div class="user_comment">
              <div class="pl_cent">
                <el-avatar :size="40" :src="itemb.teacherAvatar">
                  <img :src="morenavat" alt="" />
                </el-avatar>
                <div class="usname_comment">
                  <p class="nametxt_comment">
                    {{ itemb.teacherName }}
                    <span class="time_intera">{{ itemb.replyContentTime }}</span>
                    <span class="teach_vlog">讲师</span>
                  </p>
                  <span class="content_txtasv" v-html="itemb.replyContent"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 展开全部评论 -->
        <div class="pl_otal">
          <span @click="btninterall(inparameter)">{{
            comment.total > 5
              ? (pltxts = "点击查看全部学员评论")
              : (pltxts = "已加载全部评论")
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getToken } from "@/utils/auth.js";
import { getcomment, addcomment, delinterar } from "@/api/coursedetails.js";
export default {
  name: "interaction",
  data() {
    return {
      tokens: getToken(),
      type: "span",
      border: false,
      plone: "",
      delshow: false, //删除的模态
      delcontent: "删除后将不可恢复,是否删除", //模态框内容
      delId: null, //删除此条的ID
      pltxts: "点击查看全部学员评论",
      morenavat: require("@/assets/images/avatardefauter.png"),
      btnload: false,
    };
  },
  props: {
    //数据
    comment: {
      type: Object,
    },
    //参数
    inparameter: {
      type: Object,
    },
  },
  onLoad() {},
  methods: {
    // 发送评论
    tijone(data) {
      if (this.tokens) {
        if (!this.plone) {
          this.$message({
            message: "请输入内容",
            type: "error",
            offset: 200,
          });
          return false;
        }
        this.btnload = true;
        this.postinters(data);
      } else {
        this.$message({
          message: "请先登陆",
          type: "error",
          offset: 200,
        });
      }
    },

    postinters(data) {
      let datas = {
        courseId: data.courseId,
        chapterId: data.chapterId,
        traineeId: data.traineeId,
        traineeName: this.$store.getters.name,
        content: this.plone,
      };
      addcomment(datas).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "发表评论成功",
            type: "success",
            offset: 200,
          });
          this.plone = "";
          this.$emit("detals", data);
        }
        this.btnload = false;
      });
    },
    // 删除评论
    delintera(item, data) {
      this.delshow = true;
      this.delId = item.id;
      this.$confirm("此操作将删除该评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.confirms(data);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    confirms(data) {
      delinterar(this.delId).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success",
            offset: 200,
          });
          this.delshow = false;
          this.$emit("detals", data);
        }
      });
    },
    // 取消
    cancels() {
      this.delshow = false;
    },
    // 查看全部学员评论
    btninterall(data) {
      if (this.pltxts == "已加载全部评论") {
        this.$message({
          message: "评论已全部加载完毕",
          type: "success",
          offset: 150,
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "努力加载中....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      data.pageSize = 999;
      let intedatas = data;
      this.$emit("detals", intedatas);
      setTimeout(() => {
        loading.close();
        this.pltxts = "已加载全部评论";
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.trdetall {
  width: 100%;
}
/* 我的评论 */
.details_plwo {
  /* width: 690px; */
  margin: 0 auto;
  padding-bottom: 20px;
}
.details_inp {
  width: 100%;
  margin: 20px auto;
  margin-bottom: 10px;
}
.pl_btns {
  // width: 100%;
  margin: 0 auto;
  overflow: hidden;
  text-align: right;
  .plbtnal {
    background: #1d4434;
    border: none;
  }
}
/* 评论区 */
.details_listp {
  width: 100%;
  overflow: hidden;
}
.det_listpchile {
  /* width: 690px; */
  margin: 0 auto;
}
.det_comment {
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  &:first-of-type {
    border-top: 1px solid #e8e8e8;
  }
}
// .det_comment:hover {
//   box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
// }
.user_comment {
  width: 100%;
  display: flex;
  // justify-content: space-evenly;
}
.pl_cent {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.usimg_comment {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid #999999;
}
.usname_comment {
  flex: 1;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  margin: 0 0 0 15px;
}
.nametxt_comment {
  font-size: 12px;
  color: #1d4434;
}
/* 时间 */
.time_intera {
  font-size: 12px;
  color: #999999;
}
/* 删除按钮 */
.deltxt {
  /* display: inline-block; */
  background-color: #fa3534;
  color: #ffffff;
  padding: 5px 7px;
  border-radius: 5px;
  margin-left: 15px;
  float: right;
  cursor: pointer;
}
/* 讲师标志 */
.teach_vlog {
  display: inline-block;
  background-color: #7697ba;
  color: #ffffff;
  padding: 3px 12px;
  border-radius: 5px;
  margin-left: 15px;
  font-size: 12px;
}
.content_txtasv {
  font-size: 12px;
  color: #999999;
}
/* 内容 */
.cont_pl {
  width: 95%;
  margin: 25px 0 0 50px;
  font-weight: bold;
  color: #333333;
  font-size: 30px;
}
/* 相互回复 */
.pl_conhuifu {
  width: 95%;
  margin: 35px 0 0 40px;
  background: #f7f7f7;
  border-radius: 12px;
}
.pl_hufutxt {
  width: 95%;
  margin: 25px auto;
}
.pl_txtylpl {
  width: 100%;
  margin-top: 15px;
}
.pltxtp_name {
  font-size: 26px;
  font-weight: bold;
  color: #666666;
}
.pltxt_nrsa {
  font-size: 26px;
  font-weight: 500;
  color: #333333;
  margin-left: 15px;
}
/* 点击展开全部评论 */
.pl_otal {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
  color: #999999;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
}
.pl_otal > span:hover {
  color: #007aff;
}
</style>
